var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Network/Ethereum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.5847 0L18.3535 0.787456V23.6376L18.5847 23.8689L29.1698 17.5992L18.5847 0Z",
    fill: "#70769A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M18.5851 0L8 17.5992L18.5851 23.8689V12.7782V0Z",
    fill: "#959CBA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M18.5854 27.3198L18.4551 27.4789V35.6186L18.5854 35.9999L29.1768 21.0533L18.5854 27.3198Z",
    fill: "#71769A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M18.5851 36V27.3198L8 21.0533L18.5851 36Z",
    fill: "#959CBA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M18.5859 23.8688L29.1709 17.5993L18.5859 12.7782V23.8688Z",
    fill: "#555A82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M8 17.5992L18.5849 23.8688V12.7781L8 17.5992Z",
    fill: "#70769A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.2df8385d.svg";
export { ForwardRef as ReactComponent };